class Nav {
    constructor() {
        this.header = document.getElementById("header");
        this.btnBurger = document.getElementById("btn-burger");
        this.modalSecondary = document.getElementById("modal-secondary");
        this.navSecondaryMenu = document.getElementById("nav-secondary__menu");
        this.navSecondaryHeader = document.querySelector(".nav-secondary--header");
        this.barPromo = document.getElementById("bar-promo");
        this.lastScroll = 0;
    }

    init() {
        this.initNavPrimary();
        this.initNavSecondary();
        window.addEventListener("scroll", (e) => this.toggleStickyHeader());
    }

    //        Nav primary (main menu desk)
    // ==============================================

    initNavPrimary() {
        const items = document.querySelectorAll(".nav-primary__item");
        items.forEach((item) => {
            item.addEventListener("click", (e) => {
                const megamenu = item.querySelector(".megamenu");
                const linkText = item.querySelector(".nav-primary__link-text");
                if (!megamenu || e.target.classList.contains("nav-megamenu__link")) return;

                e.preventDefault();
                items.forEach((i) => {
                    const megamenu = i.querySelector(".megamenu");
                    const linkTextSub = i.querySelector(".nav-primary__link-text");
                    if (megamenu && i !== item) {
                        megamenu.classList.remove("active");
                        linkTextSub.classList.remove("active");
                    }
                });

                megamenu.classList.toggle("active");
                linkText.classList.toggle("active");
            });
        });
    }

    //        Nav secondary (burger menu)
    // ==============================================

    initNavSecondary() {
        this.btnBurger.addEventListener("click", (e) => this.openNavSecondary(e));
        this.modalSecondary
            .querySelector(".btn-close-modal-nav")
            .addEventListener("click", (e) => this.closeNavSecondary(e));
        this.modalSecondary
            .querySelector(".modal-secondary__overlay")
            .addEventListener("click", (e) => this.closeNavSecondary(e));
        this.navSecondaryMenu.querySelectorAll(".nav-secondary__link.has-submenu").forEach((el) => {
            el.addEventListener("click", (e) => this.openNavSecondarySubMenu(e));
        });
        this.navSecondaryMenu.querySelectorAll(".btn-back").forEach((el) => {
            el.addEventListener("click", (e) => this.closeNavSecondarySubMenu(e));
        });
    }

    openNavSecondary(e) {
        this.modalSecondary.classList.add("is-open");
        this.header.classList.add("has-nav-open");
    }

    closeNavSecondary(e) {
        this.modalSecondary.classList.remove("is-open");
        this.header.classList.remove("has-nav-open");
        this.closeNavSecondarySubMenu();
    }

    openNavSecondarySubMenu(e) {
        e.preventDefault();
        let el = e.currentTarget;
        const subnav = el.parentNode.querySelector(".nav-secondary__submenu-nav");
        this.navSecondaryMenu.classList.add("is-open");
        subnav.style.display = "block";
        setTimeout(() => {
            subnav.classList.add("is-open");
            this.navSecondaryHeader.style.justifyContent = "flex-start";
        }, 300);
    }

    closeNavSecondarySubMenu(e = null) {
        this.navSecondaryMenu.classList.remove("is-open");
        document.querySelectorAll(".nav-secondary__submenu-nav").forEach(function (el) {
            el.classList.remove("is-open");
        });
        this.navSecondaryHeader.style.justifyContent = "center";

        setTimeout(() => {
            document.querySelectorAll(".nav-secondary__submenu-nav").forEach(function (el) {
                el.style.display = "none";
            });
        }, 300);
    }

    //        Stick header on top when scroll
    // ==============================================

    toggleStickyHeader(e) {
        let currentScroll = document.body.scrollTop || document.documentElement.scrollTop;
        let limit = 0;

        // stick after bar promo
        if (this.barPromo) {
            limit += this.barPromo.offsetHeight;
        }

        // stick / unstick header
        if (currentScroll > limit) {
            this.header.classList.add("is-sticky");
            let header_height = this.header.offsetHeight;
            document.body.style.setProperty("--header-height", header_height + "px");
        } else {
            this.header.classList.remove("is-sticky");
            document.body.style.setProperty("--header-height", "0");
        }

        // // show / hide header when scroll up / down
        if (
            currentScroll > limit + 400 &&
            currentScroll > this.lastScroll &&
            !this.header.classList.contains("has-nav-open")
        ) {
            this.header.classList.add("is-close");
            // set sticky blocks position on top of window
            $(".filters-mobile-bar").removeClass("is-pushed");
            $(".sticky-store").removeClass("is-pushed");
        } else {
            this.header.classList.remove("is-close");
            // push sticky blocks position under header
            $(".filters-mobile-bar").addClass("is-pushed");
            $(".sticky-store").addClass("is-pushed");
        }
        this.lastScroll = currentScroll;
    }
}

export default new Nav();
